import { create } from 'zustand';

import {
  createSmartResizeFollowUpActionsSlice,
  type SmartResizeFollowUpActionsSlice,
} from './slices/createSmartResizeFollowUpActionsSlice';

export type SmartResizeFollowUpActionsState = SmartResizeFollowUpActionsSlice;

export const useSmartResizeFollowUpActionsStore = create<SmartResizeFollowUpActionsState>()((...args) => ({
  ...createSmartResizeFollowUpActionsSlice()(...args),
}));
